<template>
  <div style="position: relative; width: 100%; height: auto">
    <div class="main-news-wrapper">
      <div class="inner" ref="inner">
        <template v-if="latestNews.length > 0">
          <template v-for="(list, index) in latestNews" :key="index">
            <component
              :is="
                list.length !== pageSize
                  ? 'universalList'
                  : index - 1 === -1 && show.topBar
                  ? 'defaultBar'
                  : `bar${(index - (show.topBar ? 1 : 0))
                      .toString()
                      .substr(-1)}`
              "
              :list="list"
              transition-mode="out-in"
            />
          </template>
        </template>
      </div>
      <div
        v-if="show.spinner"
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 44px 0;
        "
        :style="{ height: latestNews.length > 0 ? 'unset' : '80vh' }"
      >
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  computed,
  reactive,
  onMounted,
  onBeforeUnmount,
  watch
} from "vue";
import AdditionalBar from "@/components/AdditionalBar";
import MainBar from "@/components/default/MainBar";
import FirstBar from "@/components/default/FirstBar";
import SecondBar from "@/components/default/SecondBar";
import ThirdBar from "@/components/default/ThirdBar";
import FourthBar from "@/components/default/FourthBar";
import FivthBar from "@/components/default/FivthBar";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useOrm } from "@/utils/orm";
import { useLanguage } from "@/utils/language";
import { availableCategories } from "@/utils/constants";

export default {
  components: {
    defaultBar: MainBar,

    universalList: AdditionalBar,

    bar0: FirstBar,
    bar1: SecondBar,
    bar2: ThirdBar,
    bar3: FourthBar,
    bar4: FivthBar,

    bar5: FirstBar,
    bar6: SecondBar,
    bar7: ThirdBar,
    bar8: FourthBar,
    bar9: FivthBar
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const inner = ref(null);
    const show = reactive({
      topBar: true,
      spinner: true
    });

    const { i18n } = useLanguage();

    const { getByUniqueComputed } = useOrm();

    const scrollEnd = () => {
      show.spinner = false;
    };

    const pageSize = 12;

    const { startInfiniteScroll, loadData } = useInfiniteScroll({
      wrapper: inner,
      retrieve: (load, cb) => {
        store.dispatch("getLatestNews", {
          pageSize,
          cb: () => cb(),
          category: getByUniqueComputed(
            computed(() => route.params.category),
            computed(() => store.getters.categories),
            "slug"
          )?.slug,
          load
        });
      },
      newsCount: computed(() => store.getters.newsCount),
      currentPage: computed(() => store.getters.currentPage),
      pageSize,
      scrollEnd
    });

    const checkWidth = () => {
      show.topBar = window.innerWidth >= 993;
    };

    var resizeTimeout;
    function resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function() {
          resizeTimeout = null;
          checkWidth();

          // The checkWidth will execute at a rate of 15fps
        }, 66);
      }
    }

    const refreshData = () => {
      store.commit("flushArticleState");

      show.spinner = true;
      startInfiniteScroll();
      loadData();
    };

    watch(
      () => route.params.category,
      () => {
        if (!availableCategories.includes(route.params.category)) refreshData();
      },
      { immediate: true }
    );

    watch(
      () => i18n.global.locale.value,
      refreshData
    );

    onMounted(() => {
      window.addEventListener("resize", resizeThrottler, false);
      window.addEventListener("deviceorientation", resizeThrottler, true);
      resizeThrottler();
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", resizeThrottler);
      window.removeEventListener("deviceorientation", resizeThrottler);
    });

    return {
      inner,
      show,
      pageSize,
      latestNews: computed(() => store.getters.latestNews)
    };
  }
};
</script>

<style lang="scss" scoped>
.main-news-wrapper {
  --collar-width: clamp(375px, 90%, 1720px);
  --width-content: 90%;


  width: 100%;
  position: relative;
  font-size: calc( max(16px, 0.8vw));

  .inner {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 3.125rem;
  }
}

@media screen and (max-width: 1366px) {
  .main-news-wrapper {
    font-size: 12px;
    .inner {
      zoom: 1;

      .first-spacer {
        height: calc(100vh / 0.7);
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .main-news-wrapper {
    font-size: 14px;

    .inner {
      zoom: 1;

      .first-spacer {
        height: 100vh;
      }
    }
  }
}
</style>
